module.exports = __webpack_public_path__ + "img/EuropaPlus.9190c397.png";